import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ActionBoxProps } from './types.js';

/** `<ActionBox>` component. */
export const ActionBox = ({ children, className, ...props }: ActionBoxProps): ReactElement => (
  <div
    className={twMerge(
      'flex items-center justify-between gap-16 border-b border-b-base-100 pb-24 pt-16',
      className
    )}
    {...props}
  >
    {children}
  </div>
);
